"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagKH = function FlagKH(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.06,7.06,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "64.55",
    width: "409.6",
    height: "141.24",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M105.25,65.73v-10h-3.34V49H98.58V42.36H95.24V35.69h-10v-20l3.33-3.34v-10H85.23V-4.36H81.89v-10H78.55V-21H75.21v-6.68H71.87v-3.34H65.2v3.34H61.86V-21H58.53v6.68H55.19v10H51.85V2.31h-20v-10H28.49v-10H25.15v-10H21.81V-34.4H18.48v-6.68H15.14v-3.33H13.47v-3.34H10.13v3.34H8.46v3.33H5.12v6.68H1.79v6.67H-1.55v10H-4.89v10H-8.23v10h-20V-4.36h-3.34v-10h-3.34V-21h-3.34v-6.68H-41.6v-3.34h-6.68v3.34h-3.33V-21h-3.34v6.68h-3.34v10h-3.34V2.31H-65v10l3.33,3.34v20h-10v6.67H-75V49h-3.34v6.67h-3.33v10H-85v10H108.59v-10Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagKH;
exports["default"] = _default;